// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3npw4","rootMobile":"styles_rootMobile__1gHWv"};